export default __webpack_public_path__ + "static/ogimage-503c661a9738077035c8ddfad9bb7d51.jpg";